import AEDocumentUpload from './APDocumentUpload';

export {
  AEDocumentUpload
};

export default AEDocumentUpload;